<!-- Teach Hero Section -->
<black-teach-hero-section></black-teach-hero-section>

<!-- Teach Features Section -->
<black-teach-features-section></black-teach-features-section>

<!-- Teach How It Works Section -->
<black-teach-how-it-works-section></black-teach-how-it-works-section>

<!-- Teach FAQ Section -->
<black-teach-faq-section></black-teach-faq-section>

<!-- Teach CTA Section -->
<black-teach-cta-section></black-teach-cta-section>
